export const axisInversionType = {
    normal:"normal",
    inverted:"inverted",
    special:"special"
}